import { useCallback } from 'react'
import { useConfirmOptional } from '@papan/core-ui/ui'
import { orgConnectionsApi, blockEndsConnectionConfirm } from '../client/index.js'

/**
 * dw D6 (owner ruling 2026-10-19): before a block that names an organization, ask — when the
 * blocker is CONNECTED to it, blocking also disconnects them and removes every folder shared
 * between them. Resolves true to go ahead (nothing to warn about, or the person confirmed).
 * `personal`: the block is made by the caller's PERSONAL drive (the invitation block).
 */
export function useConfirmBlockEndsConnection(): (q: { tenantId: string; personal?: boolean }) => Promise<boolean> {
  const confirm = useConfirmOptional()
  return useCallback(async (q) => {
    const impact = await orgConnectionsApi.blockImpact(q).catch(() => null)
    const warn = blockEndsConnectionConfirm(impact)
    if (!warn || !confirm) return true
    return confirm({ ...warn, type: 'danger' })
  }, [confirm])
}
